import { requestGet } from '@/common/request';

interface VerifyErpsParams {
  erps: string;
}

interface VerifyErpsRes {
  ret: string;
  msg: string;
  data: {
    validErps: {
      erp: string;
      realName: string;
    }[];
    invalidErps: string[];
  };
}

export async function VerifyErps(params: VerifyErpsParams): Promise<VerifyErpsRes> {
  return await requestGet('/commonService/verifyErps', params);
}
